import { useDynamicSmartOfferListener } from "@expert/sales-tools";

import { getSessionByTaskId } from "@/sdk/sessions/getters";

/**
 * Bridges the contactId -> sessionId mismatch for Dynamic Smart Offer events.
 *
 * The Kafka event's `sessionId` field is actually the Amazon Connect contactId,
 * which differs from the app's sessionId in callback/conference scenarios.
 * This wrapper resolves the contactId to the correct sessionId via the session store.
 */
export function useDynamicSmartOfferListenerWrapper() {
    useDynamicSmartOfferListener((contactId) => getSessionByTaskId(contactId)?.id ?? contactId);
}
